import { Injectable } from "@angular/core";
import { JwtHttpClientService } from "../http/jwt-http-client.service";
import { AbstractHttpService } from "../http/abstract-http.service";
import { EntityData } from "../index";
import { NotificationData } from "./notification.data";
export class NotificationService extends AbstractHttpService {
    constructor(http) {
        super();
        this.http = http;
    }
    /**
     * Search notifications
     * @returns {Promise<NotificationData[]>}
     */
    searchNotifications() {
        return this.http.get(NotificationService.URL_PREFIX + NotificationService.SEARCH_PREFIX)
            .map((response) => EntityData.createArray(response.json(), NotificationData))
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    getUnseenCount() {
        return this.http.get(NotificationService.URL_PREFIX + NotificationService.UNSEENCOUNT_PREFIX)
            .map((response) => parseInt(response.text()))
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    markAsViewed(identifier) {
        return this.http.get(NotificationService.URL_PREFIX + NotificationService.MARK_VIEWED_PREFIX + identifier)
            .map((response) => undefined)
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    deleteNotification(identifier) {
        return this.http.delete(NotificationService.URL_PREFIX + identifier)
            .map((response) => undefined)
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
}
NotificationService.URL_PREFIX = '/dataserver/notification/';
NotificationService.SEARCH_PREFIX = 'search/';
NotificationService.UNSEENCOUNT_PREFIX = 'unseenCount/';
NotificationService.MARK_VIEWED_PREFIX = 'viewed/';
NotificationService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
NotificationService.ctorParameters = () => [
    { type: JwtHttpClientService, },
];
//# sourceMappingURL=notification.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/notification/notification.service.js
// module id = null
// module chunks = 